function init_gamememory_album(from_php){
    var main=$(".place.gamememory");
    var girl_id=from_php.girl_id;
    var confRemember=$.takeGirlConf(girl_id,"game_memory");
    var girl_name=$.takeGirlImage(girl_id);
    function prepareAll(){
        var key,bum;
        var start_url="/gfx/place/gamememory/girls/"+girl_name+"/parts",url;
        var val=1;
        
        
        var html={"item":[]},type;
        for(key in confRemember){
            type=""
            confRemember[key].val=val;
            if(key.toString().substr(0,4)=="item"){
                type="item";
            }
            bum=confRemember[key];
            url="";
            if(type=="item"){
                url=start_url+"/ready/"+key+".png";
                
                html[type].push("<div class='iconView' style='left:"+bum.left+"px;top:"+bum.top+
                "px;width:"+bum.width+"px;height:"+bum.height+"px;"+
                "background-image:url("+url+")'></div>");
            }
        }
        main.find("#gameAllways").append(html["item"]);
        main.find("#gameAllways .eye").myEye({});
    }
    prepareAll();
    
    
    return false;
    
  
    
}